import { LineItem } from '@pperform/pp-data-mappers';
import Shipment from 'interfaces/PmParcel';

export const mapLineItemEligibility = (
  shipment: Shipment,
  nonEligibleLineItems: string[],
): Shipment => ({
  ...shipment,
  lineItems: shipment.lineItems.map((lineItem) =>
    LineItem.create({
      ...lineItem,
      eligible: !nonEligibleLineItems.includes(lineItem.guid),
    }),
  ),
});
